import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { ExtraFieldName } from '@shared/model'
import type { ExtraFieldModel } from '../../extra-field-model.hook'

import { useListsStore } from '@shared/model'

import { useSelectConfigParser } from '../../select-config-parser.hook'
import { useExtraFieldModel } from '../../extra-field-model.hook'

interface SelectRelatedToReturn {
  name: ExtraFieldName
  placeholder: string
  model: ExtraFieldModel
  options: ComputedRef<AppSelectOption[]>
  isRequired: ComputedRef<boolean>
}

export const useSelectRelatedTo = (): SelectRelatedToReturn => {
  const listsStore = useListsStore()
  const name: ExtraFieldName = 'related_to'
  const placeholder = 'Select here'

  const model = useExtraFieldModel(name)

  const {
    options,
  } = useSelectConfigParser({ name })

  const isRequired = computed(() => listsStore.getTasksKanbanConfig?.extra_fields[name]?.required || false)

  return {
    name,
    placeholder,
    model,
    options,
    isRequired,
  }
}
